import React from 'react';

const SuccessCheckIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M19 7L9 17L5 13' stroke='black' />
    </svg>
  );
};

SuccessCheckIcon.displayName = 'SuccessCheckIcon';
export default SuccessCheckIcon;
